(function () {
  'use strict';

  angular.module('imnApp').controller('TermosAceiteController', TermosAceiteController);

  TermosAceiteController.$inject = ['TermosAceiteService'];

  function TermosAceiteController(TermosAceiteService) {
    var vm = this;
    vm.abreModal = abreModal;
    vm.fecharModal = fecharModal;
    vm.modalAberta = false;

    function abreModal() {
      vm.modalAberta = true;
    }

    function fecharModal() {
      vm.modalAberta = false;
    }
  }
})();
